<template>
  <!-- 遮罩层 -->
  <div class="select-dialog-mask" v-if="visible" @click="handleClose">
    <!-- 弹框主体 -->
    <div class="select-dialog-content" @click.stop>
      <div class="radio-group">
        <!-- 单选选项列表 -->
        <label
            class="radio-item"
            :class="{ active: item.value === activeValue }"
            v-for="item in options"
            :key="item.value"
            @click="handleSelect(item)"
        >
          <input
              type="radio"
              class="radio-input"
              name="select-radio"
              :value="item.value"
              :checked="item.value === activeValue"
              disabled
          >
          <span class="radio-label">{{ item.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    activeValue: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    handleSelect(item) {
      this.$emit('select', item)
      this.handleClose()
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 通用基础样式（所有设备共享） */
.select-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-dialog-content {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  /* 关键修改：为滚动条留出空间 */
  padding: 0 20px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  /* 关键修改：将垂直内边距从 .select-dialog-content 移到这里 */
  padding: 15px 0;
}

.radio-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.radio-item:hover {
  background-color: #f5f7fa;
}

.radio-input {
  width: 16px;
  height: 16px;
  margin: 0 8px 0 0;
  cursor: pointer;
}

.radio-label {
  font-size: 14px;
  color: #333;
  transition: color 0.2s;
}

/* 选中高亮通用样式 */
.radio-item.active {
  background-color: #409eff;
}

.radio-item.active .radio-label {
  color: #fff;
}

/* 移动端（手机）适配 < 768px */
@media screen and (max-width: 768px) {
  .select-dialog-content {
    /* 关键修改：设置最大高度并允许垂直滚动 */
    max-height: 180px;
    overflow-y: auto;

    padding: 0 20px;
    min-width: 200px;
  }

  .radio-group {
    gap: 10px;
    padding: 15px 0;
  }
  .radio-input {
    width: 16px;
    height: 16px;
  }
  .radio-label {
    font-size: 15px;
  }
}

/* 平板适配 769px - 1024px */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .select-dialog-content {
    /* 关键修改：设置最大高度并允许垂直滚动 */
    max-height: 220px;
    overflow-y: auto;

    padding: 0 25px;
    min-width: 280px;
    max-width: 320px;
  }

  .radio-group {
    gap: 12px;
    padding: 20px 0;
  }

  .radio-item {
    padding: 8px 10px;
  }

  .radio-input {
    width: 18px;
    height: 18px;
  }

  .radio-label {
    font-size: 15px;
  }
}

/* PC端适配 > 1024px */
@media screen and (min-width: 1025px) {
  .select-dialog-content {
    /* 关键修改：设置最大高度并允许垂直滚动 */
    max-height: 260px;
    overflow-y: auto;

    padding: 0 30px;
    min-width: 300px;
    max-width: 350px;
  }

  .radio-group {
    gap: 14px;
    padding: 20px 0;
  }

  .radio-item {
    padding: 8px 12px;
  }

  /* PC端hover效果增强 */
  .radio-item:not(.active):hover {
    background-color: #e8f4ff;
  }

  .radio-input {
    width: 18px;
    height: 18px;
  }

  .radio-label {
    font-size: 15px;
  }

  /* PC端选中态hover增强 */
  .radio-item.active:hover {
    background-color: #3399ff;
  }
}
</style>